module.exports = __webpack_public_path__ + "static/rijkswaterstaat-920ebc17594b437f1210c29a0031cf37.svg";